import { memo } from "react";

function TotalFluid() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28 17.3852C27.93 17.3956 27.861 17.4065 27.793 17.418C26.0944 17.7038 25.0259 18.3411 24.1104 18.7451C23.2165 19.1395 22.136 19.5 20 19.5C17.4847 19.5 16.3508 19.0035 15.2373 18.4902C13.9692 17.9057 12.6442 17.25 10 17.25C7.35575 17.25 6.03076 17.9057 4.7627 18.4902C3.64921 19.0035 2.51526 19.5 0 19.5V22C2.98461 22 4.48247 21.3715 5.80957 20.7598C6.98193 20.2194 7.90708 19.75 10 19.75C12.0929 19.75 13.0181 20.2194 14.1904 20.7598C15.5175 21.3715 17.0154 22 20 22C22.4965 22 23.9201 21.5618 25.1201 21.0322C26.2336 20.5408 26.8451 20.146 28 19.9204V17.3852Z"
        fill="currentColor"
      />
      <path
        d="M28 23.3852C27.93 23.3956 27.861 23.4065 27.793 23.418C26.0944 23.7038 25.0259 24.3411 24.1104 24.7451C23.2165 25.1395 22.136 25.5 20 25.5C17.4847 25.5 16.3508 25.0035 15.2373 24.4902C13.9692 23.9057 12.6442 23.25 10 23.25C7.35575 23.25 6.03076 23.9057 4.7627 24.4902C3.64921 25.0035 2.51526 25.5 0 25.5V28C2.98461 28 4.48247 27.3715 5.80957 26.7598C6.98193 26.2194 7.90708 25.75 10 25.75C12.0929 25.75 13.0181 26.2194 14.1904 26.7598C15.5175 27.3715 17.0154 28 20 28C22.4965 28 23.9201 27.5618 25.1201 27.0322C26.2336 26.5408 26.8451 26.146 28 25.9204V23.3852Z"
        fill="currentColor"
      />
      <path
        d="M8.99802 0C8.99802 0 14.5127 6.38617 14.5127 9.45091C14.5127 12.5155 12.0436 14.9999 8.99802 15C5.95231 15 3.48337 12.5156 3.48331 9.45091C3.48331 6.38617 8.99802 0 8.99802 0Z"
        fill="currentColor"
      />
      <path
        d="M20.2466 4.24026C20.2466 4.24026 22.0255 6.30023 22.0255 7.28882C22.0255 8.27736 21.2291 9.07873 20.2466 9.07877C19.2642 9.07877 18.4678 8.27739 18.4678 7.28882C18.4678 6.30023 20.2466 4.24026 20.2466 4.24026Z"
        fill="currentColor"
      />
      <path
        d="M17.8734 9.40999C17.8734 9.40999 19.6523 11.47 19.6523 12.4585C19.6523 13.4471 18.8558 14.2485 17.8734 14.2485C16.891 14.2485 16.0946 13.4471 16.0946 12.4585C16.0946 11.47 17.8734 9.40999 17.8734 9.40999Z"
        fill="currentColor"
      />
      <path
        d="M22.7378 9.41342C22.7378 9.41342 24.5167 11.4734 24.5167 12.462C24.5167 13.4505 23.7202 14.2519 22.7378 14.2519C21.7554 14.2519 20.959 13.4505 20.959 12.462C20.959 11.4734 22.7378 9.41342 22.7378 9.41342Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(TotalFluid);
